import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Spinner,
} from 'reactstrap';
import { Paperclip } from 'phosphor-react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import api from '../../api/api';
import Cookies from 'universal-cookie';
import { processError } from '../../lib/lib';
const cookies = new Cookies();

class SupportModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      base64Files: [],
      fileSelectorPlaceholder: '',
      fileNames: [],
      disableAction: false,
    };
    this.fileSelectHandler = this.fileSelectHandler.bind(this);
  }

  convertToBase64(file) {
    // eslint-disable-next-line no-unused-vars
    return new Promise((resolve, reject) => {
      let myReader = new FileReader();
      // eslint-disable-next-line no-unused-vars
      myReader.onloadend = (e) => {
        resolve(myReader.result);
      };
      myReader.readAsDataURL(file);
    });
  }

  fileSelectHandler(e) {
    const files = Object.keys(e.target.files).map((key) => e.target.files[key]);
    let fileNames = [];
    if (Array.isArray(files) && files.length <= 10) {
      files.map(async (file) => {
        if (file !== null && file.size <= 1e6) {
          const base64Files = this.state.base64Files;
          const base64File = await this.convertToBase64(file);
          base64Files.push({ filename: file.name, content: base64File });
          fileNames.push(file.name);
          const fileSelectorPlaceholder = fileNames.join(', ');
          this.setState({ base64Files, fileSelectorPlaceholder });
        } else {
          return;
          // console.log('file size is more than 1mb')
        }
      });
    } else {
      return;
      // console.log('more than 10 files')
    }
  }

  sendMessage(e) {
    e.preventDefault();
    this.setState({ disableAction: true });
    const title = e.target.title.value;
    const message = e.target.message.value;
    const token = cookies.get('accessToken');
    const lang = this.props.i18n.language;
    const formData = {
      title,
      message,
      files: this.state.base64Files,
    };
    api
      .sendSupportEmail({ token, lang, formData })
      .then((res) => {
        res.data.success ? this.props.setSent(true) : this.props.setSent(false);
        this.props.toggle();
        this.setState({ disableAction: false });
      })
      .catch((e) => processError(e, this.props.history));
  }

  render() {
    const { t } = this.props;
    return (
      <Modal
        isOpen={this.props.isOpen}
        toggle={this.props.toggle}
        className="header-support-modal"
      >
        <ModalHeader toggle={this.props.toggle} className="lg-font-size">
          {t('support-appeal')}
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={(e) => this.sendMessage(e)}>
            <FormGroup>
              <Label for="support_theme" className="support-label sm-font-size">
                {t('support-theme')}
              </Label>
              <Input
                type="text"
                name="title"
                id="support_theme"
                placeholder={t('support-theme-ph')}
                className="md-font-size"
              />
            </FormGroup>
            <FormGroup>
              <Label for="support_text" className="support-label sm-font-size">
                {t('support-text')}
              </Label>
              <Input
                type="textarea"
                name="message"
                id="support_text"
                placeholder={t('support-text-ph')}
                className="md-font-size"
              />
            </FormGroup>
            <FormGroup>
              <Label className="header-modal-btn" htmlFor="support_file">
                <span className="md-font-size">
                  {this.state.fileSelectorPlaceholder || t('support-attach')}
                </span>
                <Paperclip size={24} className="icon" />
              </Label>
              <Input
                className="d-none"
                type="file"
                name="file"
                accept=".png, .jpg"
                onChange={this.fileSelectHandler}
                id="support_file"
                multiple
              />
            </FormGroup>
            <Button
              disabled={this.state.disableAction}
              type="submit"
              className="md-font-size profile-avatar-btn primary"
            >
              {this.state.disableAction ? (
                <Spinner size="sm" />
              ) : (
                t('support-send')
              )}
            </Button>
          </Form>
        </ModalBody>
      </Modal>
    );
  }
}

SupportModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  t: PropTypes.func,
  history: PropTypes.object,
  i18n: PropTypes.object,
  setSent: PropTypes.func,
};

export default withTranslation()(SupportModal);



// WEBPACK FOOTER //
// ./src/components/Header/SupportModal.jsx